module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAAAe1BMVEUAAAA3SGg1RWowQGA3SGg4SGk4SGg3SGg3SGg4SGgAgP83SGo4SWk2Sm0Agf8Agf84SGgZZ7s2SWoAgf8Agf84SGgAgf83SWg4SGgAgP82SWkYZ74AgP84SGgAgP8nWZY4SWkAgf8Id+gWacIrVIo0THIDfPUjXaExT3v1NbCSAAAAIHRSTlMA8DAQ0KBgsHAgEPPA9/Dg39fT0KCfkJCAYFBKQEAwLupDcGEAAAClSURBVDjL7dFZEoMgEEXRBnE28zy/JGbY/woTCuwPBDag58uirhbd0mhwqsUXHkq64Ql+czeUeD3ubFaZ0wyCXDnad9dNr/ZtgYJcyRJtF57tkUBKfWWNj+kOtlNoyEfWeOpuy5dRCXll0OWajBRCUkDxH33FA8PX8VcmN/N0BDKKaOy9pMA+kPCkOS8mqhTY6FzFIv4b7mKCS+LFxF3SXUmjAfsBe2cSYs3nNNoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./packages/theme-chalk/src/images/icon-down-arrow@2x.png
// module id = 82
// module chunks = 0